export default "__VITE_ASSET__BxHh5riZ__"